var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"d-flex align-center",style:('background-color:' + _vm.lm.color+' ;'),attrs:{"cols":"12","md":"6","order-md":"2"}},[_c('v-img',{attrs:{"src":_vm.imgSrc(_vm.index)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }